import React, { Component } from 'react'
export default function About(){
    return(<>About</>)
}